import amir from '../../assets/amir.jpg'
import marwa from '../../assets/marwa.jpg'
import souheir from '../../assets/souheir.jpg' 
export const testimonials = [
  {
    name: "Amir Kassha",
    image: amir,
    content:
      "Ofok was a game-changer for my high school exam prep. The personalized study paths helped me stay organized, and the live sessions added a dynamic touch to my learning. I felt confident and well-prepared on exam day. Thank you, ExamHub!",
    rate: 5, // Rating out of 5
  },
  {
    name: "Souheir Jammal",
    image: souheir,
    content:
      "As a teacher, Ofok has made it easier than ever to connect with my students. I can seamlessly schedule and host sessions, ensuring they get the support they need. The platform's intuitive design and diverse resources make it an invaluable tool for educators.",
    rate: 4.5, // Rating out of 5
  },
  {
    name: "Marwa Kassha",
    image: marwa,
    content:
      "I'm impressed with how Ofok has positively impacted my child's study routine. The structured paths keep them on track, and the session updates allow me to stay informed. It’s a reliable and user-friendly platform that truly supports academic success.",
    rate: 4, // Rating out of 5
  },
  {
    name: "Marwa Kassha",
    image: marwa,
    content:
      "I'm impressed with how Ofok has positively impacted my child's study routine. The structured paths keep them on track, and the session updates allow me to stay informed. It’s a reliable and user-friendly platform that truly supports academic success.",
    rate: 4, // Rating out of 5
  },
];
